
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { IAppointmentData } from 'src/app/models/IAppointmentDetails';
import { ToastrService } from 'ngx-toastr';
export interface DialogData { }

export interface AppointmentInformation {
  patinfo: IAppointmentData;
}
@Component({
  selector: 'app-appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: ['./appointment-details.component.css']
})
export class AppointmentDetailsComponent implements OnInit {

  AppointmentDetailsForm: FormGroup;

  public patientName: string = "";
  public providerName: string = "";
  public visitType: string = "";
  public comments: string = "";
  public location: string = "";
  public appointmentDate: string = "";
  appointmentId: string = '';
  appointmentInfo: IAppointmentData;
  constructor(private formBuilder: FormBuilder, public dialog: MatDialog, private schedulerservice: SchedularServiceService,
    public dialogRef: MatDialogRef<AppointmentDetailsComponent>, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: AppointmentInformation,) {

    this.patientName = data.patinfo.name;
    this.providerName = data.patinfo.phyName;
    this.visitType = data.patinfo.visitType;
    this.comments = data.patinfo.notesDetails;
    this.location = data.patinfo.location;
    this.appointmentDate = data.patinfo.start;
    this.appointmentId = data.patinfo.Id;
   // alert(this.comments)
  }

  
  ngOnInit() {
    this.AppointmentDetailsForm = this.formBuilder.group({
      comments: [''],
    })
    this.AppointmentDetailsForm.patchValue({
      comments: this.comments,
    })
  }

  updateComments() {
    var commentText : string = this.AppointmentDetailsForm.value.comments;
   if(commentText !=''){
    this.schedulerservice.UpdatePatientBoardComments(this.appointmentId, commentText).subscribe(
      results => {
        this.toastr.success(results);
        this.dialogRef.close(true);
      }, (err: any) => {
        console.log(err);
      });
  
   }else{
    this.toastr.warning('Please Enter Comments.');
   }
  }
  onCancelClick(){
    this.dialogRef.close();
  }
  onNoClick(){
    this.dialogRef.close();
  }
}

